var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12"}},[_c('List',{staticClass:"text-small text-grey",attrs:{"items":_vm.bulletsList,"variant":"numbers"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }